import { Union, Record } from "../../fable_modules/fable-library-js.4.25.0/Types.js";
import { tuple_type, list_type, record_type, lambda_type, class_type, union_type, option_type, string_type, unit_type } from "../../fable_modules/fable-library-js.4.25.0/Reflection.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library-js.4.25.0/Result.js";
import { StateResultMsg$6, StateMachineMsg$5_$reflection } from "../../fable_modules/Webbler.StateMachine.Core.1.3.1/StateMachine.fs.js";
import { map, singleton } from "../../fable_modules/fable-library-js.4.25.0/List.js";
import { Cmd_map, Cmd_none } from "../../fable_modules/Fable.Elmish.4.4.0/cmd.fs.js";
import { CrudControls_ButtonClick, Shared_SharedCrudModel$4_$reflection, CrudControls_CrudFormField$2_$reflection, CrudControls_ButtonClick_$reflection, Shared_updateInboundModification, Shared_SharedCrudModel$4 } from "../SharedCrud.js";
import { Cmd_OfAsyncWith_either } from "../../fable_modules/Fable.Elmish.4.4.0/cmd.fs.js";
import { AsyncHelpers_start } from "../../fable_modules/Fable.Elmish.4.4.0/prelude.fs.js";
import { curry2 } from "../../fable_modules/fable-library-js.4.25.0/Util.js";
import { printf, toText } from "../../fable_modules/fable-library-js.4.25.0/String.js";
import { some } from "../../fable_modules/fable-library-js.4.25.0/Option.js";
import * as react from "react";

export class Model$4 extends Record {
    constructor(activeItem, isValid, save) {
        super();
        this.activeItem = activeItem;
        this.isValid = isValid;
        this.save = save;
    }
}

export function Model$4_$reflection(gen0, gen1, gen2, gen3) {
    return record_type("ThreeDocs.Client.StateMachine.Crud.Substates.CrudDataEntry.Model`4", [gen0, gen1, gen2, gen3], Model$4, () => [["activeItem", gen0], ["isValid", union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, option_type(string_type)], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", option_type(string_type)]]])], ["save", lambda_type(gen2, lambda_type(gen0, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [gen0, gen1], FSharpResult$2, () => [[["ResultValue", gen0]], [["ErrorValue", gen1]]])])))]]);
}

export class InternalMsg$4 extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetItemVm", "Save", "Validate", "SaveResult", "ExceptionError", "Cancel", "SendOutbound"];
    }
}

export function InternalMsg$4_$reflection(gen0, gen1, gen2, gen3) {
    return union_type("ThreeDocs.Client.StateMachine.Crud.Substates.CrudDataEntry.InternalMsg`4", [gen0, gen1, gen2, gen3], InternalMsg$4, () => [[["Item", lambda_type(gen0, gen0)]], [], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [gen0, gen1], FSharpResult$2, () => [[["ResultValue", gen0]], [["ErrorValue", gen1]]])]], [["Item", class_type("System.Exception")]], [], [["Item", gen1]]]);
}

export class Transitions$8 extends Record {
    constructor(ItemSaved, Cancel) {
        super();
        this.ItemSaved = ItemSaved;
        this.Cancel = Cancel;
    }
}

export function Transitions$8_$reflection(gen0, gen1, gen2, gen3, gen4, gen5, gen6, gen7) {
    return record_type("ThreeDocs.Client.StateMachine.Crud.Substates.CrudDataEntry.Transitions`8", [gen0, gen1, gen2, gen3, gen4, gen5, gen6, gen7], Transitions$8, () => [["ItemSaved", lambda_type(gen1, lambda_type(Model$4_$reflection(gen7, gen4, gen5, gen6), tuple_type(gen0, list_type(lambda_type(lambda_type(StateMachineMsg$5_$reflection(gen0, gen1, gen2, gen3, gen4), unit_type), unit_type)), gen1)))], ["Cancel", lambda_type(gen1, lambda_type(Model$4_$reflection(gen7, gen4, gen5, gen6), tuple_type(gen0, list_type(lambda_type(lambda_type(StateMachineMsg$5_$reflection(gen0, gen1, gen2, gen3, gen4), unit_type), unit_type)), gen1)))]]);
}

export function init(shared, activeItem, saveAction) {
    return [new Model$4(activeItem, new FSharpResult$2(1, ["Invalid"]), saveAction), singleton((dispatch) => {
        dispatch(new StateResultMsg$6(0, [new InternalMsg$4(2, [])]));
    }), shared];
}

export function updateInbound(transitions, token, msg, sharedModel, model) {
    switch (msg.tag) {
        case 3:
            return [model, Cmd_none(), new Shared_SharedCrudModel$4(sharedModel.ItemList, sharedModel.Search, sharedModel.ItemConfig, sharedModel.SortInfo, sharedModel.ListModifications, msg.fields[0])];
        case 4:
            return [model, Cmd_none(), new Shared_SharedCrudModel$4(sharedModel.ItemList, sharedModel.Search, sharedModel.ItemConfig, sharedModel.SortInfo, sharedModel.ListModifications, msg.fields[0](sharedModel.CustomStorage))];
        case 1:
            return [model, Cmd_none(), Shared_updateInboundModification(msg.fields[0], sharedModel)];
        case 2:
            return [model, Cmd_none(), sharedModel];
        default:
            return [model, Cmd_none(), new Shared_SharedCrudModel$4(msg.fields[0], sharedModel.Search, sharedModel.ItemConfig, sharedModel.SortInfo, sharedModel.ListModifications, sharedModel.CustomStorage)];
    }
}

export function update(transitions, updateArgs, msg, sharedModel, model) {
    let msg_5, msg_9, msg_1;
    switch (msg.tag) {
        case 0:
            return [new Model$4(msg.fields[0](model.activeItem), model.isValid, model.save), singleton((dispatch_1) => {
                dispatch_1(new StateResultMsg$6(0, [new InternalMsg$4(2, [])]));
            }), sharedModel];
        case 2:
            return [new Model$4(model.activeItem, sharedModel.ItemConfig.validateItem(updateArgs, sharedModel.CustomStorage, model.activeItem), model.save), Cmd_none(), sharedModel];
        case 1:
            return [model, Cmd_map((Item_4) => (new StateResultMsg$6(0, [Item_4])), Cmd_OfAsyncWith_either((x) => {
                AsyncHelpers_start(x);
            }, curry2(model.save)(updateArgs), model.activeItem, (Item_2) => (new InternalMsg$4(3, [Item_2])), (Item_3) => (new InternalMsg$4(4, [Item_3])))), sharedModel];
        case 3:
            if (msg.fields[0].tag === 1) {
                return [model, singleton((dispatch_3) => {
                    dispatch_3(new StateResultMsg$6(2, [msg.fields[0].fields[0]]));
                }), sharedModel];
            }
            else {
                const updatedModel = new Model$4(msg.fields[0].fields[0], model.isValid, model.save);
                return [updatedModel, (msg_5 = (new StateResultMsg$6(1, [transitions.ItemSaved(sharedModel, updatedModel)])), singleton((dispatch_2) => {
                    dispatch_2(msg_5);
                })), sharedModel];
            }
        case 5:
            return [model, (msg_9 = (new StateResultMsg$6(1, [transitions.Cancel(sharedModel, model)])), singleton((dispatch_4) => {
                dispatch_4(msg_9);
            })), sharedModel];
        case 6:
            return [model, singleton((dispatch_5) => {
                dispatch_5(new StateResultMsg$6(2, [msg.fields[0]]));
            }), sharedModel];
        default: {
            console.error(some(toText(printf("Error: %O"))(msg.fields[0])));
            return [model, (msg_1 = (new StateResultMsg$6(2, [sharedModel.ItemConfig.exceptionToOutbound(msg.fields[0])])), singleton((dispatch) => {
                dispatch(msg_1);
            })), sharedModel];
        }
    }
}

export class Buttons extends Record {
    constructor(save, cancel) {
        super();
        this.save = save;
        this.cancel = cancel;
    }
}

export function Buttons_$reflection() {
    return record_type("ThreeDocs.Client.StateMachine.Crud.Substates.CrudDataEntry.Buttons", [], Buttons, () => [["save", CrudControls_ButtonClick_$reflection()], ["cancel", CrudControls_ButtonClick_$reflection()]]);
}

export class FormViewConfig$2 extends Record {
    constructor(formFields) {
        super();
        this.formFields = formFields;
    }
}

export function FormViewConfig$2_$reflection(gen0, gen1) {
    return record_type("ThreeDocs.Client.StateMachine.Crud.Substates.CrudDataEntry.FormViewConfig`2", [gen0, gen1], FormViewConfig$2, () => [["formFields", list_type(CrudControls_CrudFormField$2_$reflection(gen0, gen1))]]);
}

export class ViewLayoutConfig$4 extends Record {
    constructor(fieldViewParentElement) {
        super();
        this.fieldViewParentElement = fieldViewParentElement;
    }
}

export function ViewLayoutConfig$4_$reflection(gen0, gen1, gen2, gen3) {
    return record_type("ThreeDocs.Client.StateMachine.Crud.Substates.CrudDataEntry.ViewLayoutConfig`4", [gen0, gen1, gen2, gen3], ViewLayoutConfig$4, () => [["fieldViewParentElement", lambda_type(FormViewConfig$2_$reflection(gen0, gen3), lambda_type(Shared_SharedCrudModel$4_$reflection(gen0, gen1, gen2, gen3), lambda_type(Model$4_$reflection(gen0, gen1, gen2, gen3), lambda_type(class_type("Fable.React.ReactElement", undefined), lambda_type(Buttons_$reflection(), lambda_type(lambda_type(gen1, unit_type), class_type("Fable.React.ReactElement", undefined)))))))]]);
}

export function makeDataEntryFormElement(config, activeItem, customStorage, dispatch) {
    const children = map((field) => field.mkFormField(activeItem, customStorage, (arg) => {
        dispatch(new InternalMsg$4(0, [arg]));
    }), config.formFields);
    return react.createElement("form", {}, ...children);
}

export function view(formConfig, viewLayoutConfig, sharedModel, model, dispatch) {
    const children = [viewLayoutConfig.fieldViewParentElement(formConfig, sharedModel, model, makeDataEntryFormElement(formConfig, model.activeItem, sharedModel.CustomStorage, dispatch), new Buttons(new CrudControls_ButtonClick("Save", (_arg) => {
        dispatch(new InternalMsg$4(1, []));
    }), new CrudControls_ButtonClick("Cancel", (_arg_1) => {
        dispatch(new InternalMsg$4(5, []));
    })), (arg) => {
        dispatch(new InternalMsg$4(6, [arg]));
    })];
    return react.createElement("div", {}, ...children);
}

